import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import classnames from 'classnames';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import SharedContactDealerWrapper from '../../contactDealer/SharedContactDealerWrapper';

// styles
import styles from './PdpSharedButtons.scss';

export const PdpSharedContactDealerButton = ({
    fullWidth,
    type,
    launchOrigin,
    item,
    size,
    user = {},
}) => {
    const buttonClassName = classnames(styles.button, { [styles.fullWidth]: fullWidth });
    const buttonType = size === 'small' ? 'secondary' : '';

    const askSellerMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.askSeller"
            defaultMessage="Ask the seller"
        />
    );

    const requestCustomizationMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestCustomization"
            defaultMessage="Request More Info"
        />
    );

    const requestPriceMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestPrice"
            defaultMessage="Request Price"
        />
    );

    const requestMoreImages = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestMoreImages"
            defaultMessage="Request More Images"
        />
    );

    let modalType = 'CONTACT_DEALER';
    let message;

    switch (type) {
        case 'REQUEST_PRICE':
            message = requestPriceMessage;
            launchOrigin = 'request price button';
            modalType = type;
            break;
        case 'REQUEST_CUSTOMIZATION':
            message = requestCustomizationMessage;
            break;
        case 'REQUEST_IMAGES':
            message = requestMoreImages;
            modalType = type;
            break;
        default:
            message = askSellerMessage;
            break;
    }

    return (
        <SharedContactDealerWrapper
            item={item}
            launchOrigin={launchOrigin}
            modalType={modalType}
            user={user}
        >
            <Button
                type={buttonType}
                className={buttonClassName}
                dataTn="item-actions-request-information"
                size={size}
            >
                {message}
            </Button>
        </SharedContactDealerWrapper>
    );
};

PdpSharedContactDealerButton.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    type: PropTypes.oneOf([
        'CONTACT_DEALER',
        'REQUEST_CUSTOMIZATION',
        'REQUEST_PRICE',
        'REQUEST_IMAGES',
    ]),
    fullWidth: PropTypes.bool,
    launchOrigin: PropTypes.string,
};

PdpSharedContactDealerButton.defaultProps = {
    size: 'large',
    type: 'CONTACT_DEALER',
    launchOrigin: 'contact link in pdp - sidebar',
    fullWidth: true,
};

export default createFragmentContainer(PdpSharedContactDealerButton, {
    item: graphql`
        fragment PdpSharedContactDealerButton_item on Item {
            ...SharedContactDealerWrapper_item
        }
    `,
    user: graphql`
        fragment PdpSharedContactDealerButton_user on User {
            ...SharedContactDealerWrapper_user
        }
    `,
});
